import NetworkingOperations from "../index";

const PaymentInitTourist = (data) => {
	const url = process.env.REACT_APP_PAYMENT_INIT_TOURIST;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentInitTourist;
